import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'eligiblecourses-dialog-component',
    styleUrls: ['eligiblecourses.dialogcomponent.scss'],
    templateUrl: 'eligiblecourses.dialogcomponent.html',
})
export class EligibleCoursesDialogComponent implements OnInit {
    canceltext: string;
    message: string;
    oktext: string;
    title: string;
    Courses: number[];

    constructor(
        public dialogRef: MatDialogRef<EligibleCoursesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: _EligibleCoursesDialogOptions
    ) {
        this.canceltext = data.CancelText || 'Cancel';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'Update Courses';
        this.title = data.TitleText || 'Choose Eligibility Courses';
        this.Courses = data.Courses || [];
    }

    ngOnInit() {}

    // #region Cancel Handler Method

    CancelHandler() {
        this.dialogRef.close(null);
    }

    // #endregion

    // #region OK Handler Method

    OkHandler() {
        this.dialogRef.close(this.Courses);
    }

    // #endregion
}

// #region Custom Classes

// #region Eligible Courses Dialog Options Class

export interface _EligibleCoursesDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Courses?: number[];
}

// #endregion

// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/eligiblecourses/eligiblecourses.dialogcomponent.ts